<!-- <div class="upload-container" (click)="fileInput.click()">
  <i class="material-icons upload-container__icon">
    add_a_photo
  </i>
  <input style="display: none;" type="file"
         #fileInput
         (change)="onSelectPhoto($event)">
</div> -->


<div class="upload-container" (click)="fileInput.click()" *ngIf="!photoLoading">
  <i class="material-icons upload-container__icon">
    add_a_photo
  </i>
  <input style="display: none;" type="file"
         #fileInput
         (change)="onSelectPhoto($event)">
</div>
<mat-spinner diameter="24" *ngIf="photoLoading"></mat-spinner>